import moment from 'moment';

export const determineFirstInvestment = (chosenDate: number, frequencySelection: string): string => {
	const now = moment();
	const firstDate = moment().date(chosenDate);
	const firstDateMonthLater = moment().date(chosenDate).add(1, 'M');
	const dateFormat = 'dddd, MMMM Do YYYY';
	let firstInvestmentDate = '';

	if (frequencySelection === 'SEMI_MONTHLY') {
		const secondDate = moment().date(chosenDate).add(14, 'd');

		if (firstDate.isAfter(now)) {
			firstInvestmentDate = firstDate.format(dateFormat);
		} else if (secondDate.isAfter(now)) {
			firstInvestmentDate = secondDate.format(dateFormat);
		} else {
			firstInvestmentDate = firstDateMonthLater.format(dateFormat);
		}
	} else {
		if (firstDate.isAfter(now)) {
			firstInvestmentDate = firstDate.format(dateFormat);
		} else {
			firstInvestmentDate = firstDateMonthLater.format(dateFormat);
		}
	}

	return firstInvestmentDate;
};

export const isValidAccountStatementDate = (yearMonthDay: string): boolean => {
	const date = moment(yearMonthDay, 'YYYY-MM-DD', true);
	const isProvidedDateBeforeToday = date.isBefore(moment(), 'day');
	const isProvidedDateEndOfMonth = yearMonthDay === date.endOf('month').format('YYYY-MM-DD');
	return isProvidedDateBeforeToday && isProvidedDateEndOfMonth;
};
